'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entityAliases = require('./alias/entity-aliases.controller');

var _entityAliases2 = _interopRequireDefault(_entityAliases);

var _entityAliasDialog = require('./alias/entity-alias-dialog.controller');

var _entityAliasDialog2 = _interopRequireDefault(_entityAliasDialog);

var _entityTypeSelect = require('./entity-type-select.directive');

var _entityTypeSelect2 = _interopRequireDefault(_entityTypeSelect);

var _entityTypeList = require('./entity-type-list.directive');

var _entityTypeList2 = _interopRequireDefault(_entityTypeList);

var _entitySubtypeList = require('./entity-subtype-list.directive');

var _entitySubtypeList2 = _interopRequireDefault(_entitySubtypeList);

var _entitySubtypeSelect = require('./entity-subtype-select.directive');

var _entitySubtypeSelect2 = _interopRequireDefault(_entitySubtypeSelect);

var _entitySubtypeAutocomplete = require('./entity-subtype-autocomplete.directive');

var _entitySubtypeAutocomplete2 = _interopRequireDefault(_entitySubtypeAutocomplete);

var _entityAutocomplete = require('./entity-autocomplete.directive');

var _entityAutocomplete2 = _interopRequireDefault(_entityAutocomplete);

var _entityList = require('./entity-list.directive');

var _entityList2 = _interopRequireDefault(_entityList);

var _entitySelect = require('./entity-select.directive');

var _entitySelect2 = _interopRequireDefault(_entitySelect);

var _entityFilter = require('./entity-filter.directive');

var _entityFilter2 = _interopRequireDefault(_entityFilter);

var _entityFilterView = require('./entity-filter-view.directive');

var _entityFilterView2 = _interopRequireDefault(_entityFilterView);

var _aliasesEntitySelectPanel = require('./alias/aliases-entity-select-panel.controller');

var _aliasesEntitySelectPanel2 = _interopRequireDefault(_aliasesEntitySelectPanel);

var _aliasesEntitySelect = require('./alias/aliases-entity-select.directive');

var _aliasesEntitySelect2 = _interopRequireDefault(_aliasesEntitySelect);

var _addAttributeDialog = require('./attribute/add-attribute-dialog.controller');

var _addAttributeDialog2 = _interopRequireDefault(_addAttributeDialog);

var _addWidgetToDashboardDialog = require('./attribute/add-widget-to-dashboard-dialog.controller');

var _addWidgetToDashboardDialog2 = _interopRequireDefault(_addWidgetToDashboardDialog);

var _attributeTable = require('./attribute/attribute-table.directive');

var _attributeTable2 = _interopRequireDefault(_attributeTable);

var _relationFilters = require('./relation/relation-filters.directive');

var _relationFilters2 = _interopRequireDefault(_relationFilters);

var _relationTable = require('./relation/relation-table.directive');

var _relationTable2 = _interopRequireDefault(_relationTable);

var _relationTypeAutocomplete = require('./relation/relation-type-autocomplete.directive');

var _relationTypeAutocomplete2 = _interopRequireDefault(_relationTypeAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.entity', []).controller('EntityAliasesController', _entityAliases2.default).controller('EntityAliasDialogController', _entityAliasDialog2.default).controller('AliasesEntitySelectPanelController', _aliasesEntitySelectPanel2.default).controller('AddAttributeDialogController', _addAttributeDialog2.default).controller('AddWidgetToDashboardDialogController', _addWidgetToDashboardDialog2.default).directive('tbEntityTypeSelect', _entityTypeSelect2.default).directive('tbEntityTypeList', _entityTypeList2.default).directive('tbEntitySubtypeList', _entitySubtypeList2.default).directive('tbEntitySubtypeSelect', _entitySubtypeSelect2.default).directive('tbEntitySubtypeAutocomplete', _entitySubtypeAutocomplete2.default).directive('tbEntityAutocomplete', _entityAutocomplete2.default).directive('tbEntityList', _entityList2.default).directive('tbEntitySelect', _entitySelect2.default).directive('tbEntityFilter', _entityFilter2.default).directive('tbEntityFilterView', _entityFilterView2.default).directive('tbAliasesEntitySelect', _aliasesEntitySelect2.default).directive('tbAttributeTable', _attributeTable2.default).directive('tbRelationFilters', _relationFilters2.default).directive('tbRelationTable', _relationTable2.default).directive('tbRelationTypeAutocomplete', _relationTypeAutocomplete2.default).name;


// WEBPACK FOOTER //
// ./src/app/entity/index.js